import { createServerFn } from '@tanstack/react-start';
import { getRequest } from '@tanstack/react-start/server';

import { getUserNotificationsSorted } from '~/database/supabase/notifications/queries.server.ts';
import type { CleanNotificationWithRelations } from '~/database/supabase/notifications/types.ts';
import { getHints } from '~/utils/client-hints.tsx';

import { requireStartAuthSession } from '../auth/require-start-auth-session.ts';
import { createServerFnObservabilityMiddleware } from '../utils/create-instrumented-server-fn.ts';

export interface NotificationsPageData {
	readonly notifications: CleanNotificationWithRelations[];
	readonly userLocale: string;
}

export const getNotificationsPageData = createServerFn({ method: 'GET' })
	.middleware([
		createServerFnObservabilityMiddleware({
			dependencies: ['auth.session', 'supabase.notifications.sorted'],
			relatesTo: 'notifications.page',
		}),
	])
	.handler(async (): Promise<NotificationsPageData> => {
		const request = getRequest();
		const authSession = await requireStartAuthSession({ request });
		const userLocale = getHints(request).locale;
		const notifications = (await getUserNotificationsSorted(authSession.userId, true, false)) ?? [];

		return {
			notifications,
			userLocale,
		};
	});
